import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'IsFMCard',
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: 'secondary'
    },
    elevation: {
      type: [Number, String],
      default: 10
    },
    inline: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, String],
      default: 24
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasOffset: function hasOffset() {
      return this.$slots.header || this.$slots.offset || this.title || this.text;
    },
    styles: function styles() {
      if (!this.hasOffset) {
        return null;
      }

      return {
        marginBottom: "".concat(this.offset, "px"),
        marginTop: "".concat(this.offset * 2, "px")
      };
    }
  }
};